import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTopButton from './components/ScrollToTopButton';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './Home';

const Ruta = React.lazy(() => import('./pages/Ruta'));
const Localidades = React.lazy(() => import('./pages/Localidades'));
const Festividades = React.lazy(() => import('./pages/Festividades'));
const Actividades = React.lazy(() => import('./pages/Actividades'));
const Campanas = React.lazy(() => import('./pages/Campanas'));
const MitzvaTankMundo = React.lazy(() => import('./pages/MitzvaTankMundo'));
const Galeria = React.lazy(() => import('./pages/Galeria'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));

function PageLoader() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
      <CircularProgress sx={{ color: '#600002' }} />
    </Box>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Suspense fallback={<PageLoader />}>
                  <Dashboard />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="/*"
            element={
              <>
                <Header />
                <Suspense fallback={<PageLoader />}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/ruta" element={<Ruta />} />
                    <Route path="/localidades" element={<Localidades />} />
                    <Route path="/festividades" element={<Festividades />} />
                    <Route path="/actividades" element={<Actividades />} />
                    <Route path="/campanas" element={<Campanas />} />
                    <Route path="/mitzva-tank-mundo" element={<MitzvaTankMundo />} />
                    <Route path="/galeria" element={<Galeria />} />
                  </Routes>
                </Suspense>
                <Footer />
                <WhatsAppButton />
                <ScrollToTopButton />
              </>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
